@if (allowReset) {
  <form [formGroup]="fG">
    <input ejs-rating [formControlName]="fCN" [showLabel]="showLabel" [labelPosition]="'Top'" [precision]="halfStep ? 'Half' : 'Full'" [allowReset]="true" [disabled]="disabled"/>
    <div class="error-label" role="alert">
      {{ fG.controls[fCN].invalid && fG.controls[fCN].dirty ? (errorText || ('FORMVALIDATIONREQUIRED' | translate)) : '' }}
    </div>
  </form>
}
@if (!allowReset) {
  <form [formGroup]="fG">
    <input ejs-rating [formControlName]="fCN" [showLabel]="showLabel" [labelPosition]="'Top'" [precision]="halfStep ? 'Half' : 'Full'" [allowReset]="false" [disabled]="disabled"/>
    <div class="error-label" role="alert">
      {{ fG.controls[fCN].invalid && fG.controls[fCN].dirty ? (errorText || ('FORMVALIDATIONREQUIRED' | translate)) : '' }}
    </div>
  </form>
}
